import {
  InputMultiSelectControl,
  MultiSelect,
  SelectDropdownListFooter,
  SelectDropdownListHeader,
} from '../../Select'
import { BuildingSelect } from '../BuildingSelect'

import { BUILDING_MULTI_SELECT_DROPDOWN_FLOATING_CONFIG_SELECT_ALL } from './BuildingMultiSelect.constants'

import BuildingIcon from '../../../icons/building.svg'

function BuildingMultiSelect({
  Control = InputMultiSelectControl,
  dropdownFloatingConfig = BUILDING_MULTI_SELECT_DROPDOWN_FLOATING_CONFIG_SELECT_ALL,
  listProps,
  tagsProps,
  onClear,
  onSelectItem,
  ...restProps
}) {
  return (
    <MultiSelect
      {...restProps}
      Control={Control}
      EntityIcon={BuildingIcon}
      Select={BuildingSelect}
      dropdownFloatingConfig={dropdownFloatingConfig}
      listProps={{
        ...listProps,
        Footer: listProps?.SelectDropdownListFooter || SelectDropdownListFooter,
        Header: listProps?.SelectDropdownListHeader || SelectDropdownListHeader,
      }}
      tagsProps={{
        ...tagsProps,
        onChange: onSelectItem,
        onClear,
      }}
      onClear={onClear}
      onSelectItem={onSelectItem}
    />
  )
}

export default BuildingMultiSelect
